const WHW_GET_EMAIL_AND_MTN = 'WHW_GET_EMAIL_AND_MTN';
const WHW_GET_EMAIL_AND_MTN_SUCCESS = 'WHW_GET_EMAIL_AND_MTN_SUCCESS';
const WHW_GET_EMAIL_AND_MTN_FAIL = 'WHW_GET_EMAIL_AND_MTN_FAIL';
const WHW_GEN_INSPICIO_ID = 'WHW_GEN_INSPICIO_ID';
const WHW_GEN_INSPICIO_ID_SUCCESS = 'WHW_GEN_INSPICIO_ID_SUCCESS';
const WHW_GEN_INSPICIO_ID_FAIL = 'WHW_GEN_INSPICIO_ID_FAIL';
const WHW_SEND_SMS_EMAIL_INSPICIO = 'WHW_SEND_SMS_EMAIL_INSPICIO';
const WHW_SEND_SMS_EMAIL_INSPICIO_SUCCESS = 'WHW_SEND_SMS_EMAIL_INSPICIO_SUCCESS';
const WHW_SEND_SMS_EMAIL_INSPICIO_FAIL = 'WHW_SEND_SMS_EMAIL_INSPICIO_FAIL';
const WHW_INITIAL_STATE = 'WHW_INITIAL_STATE';
const WHW_INSPECIO_FORGET_PIN = 'WHW_INSPECIO_FORGET_PIN';
const WHW_SEND_MESSAGE_INSPICIO = 'WHW_SEND_MESSAGE_INSPICIO';
const WHW_INSPECIO_SHOWFORGETPIN_SUCCESS = 'WHW_INSPECIO_SHOWFORGETPIN_SUCCESS';
const WHW_INSPECIO_SENDMESSAGE_SUCCESS = 'WHW_INSPECIO_SENDMESSAGE_SUCCESS';
const WHW_INSPECIO_SHOWFORGETPIN_FAIL = 'WHW_INSPECIO_SHOWFORGETPIN_FAIL';
const WHW_INSPECIO_SENDMESSAGE_FAIL = 'WHW_INSPECIO_SENDMESSAGE_FAIL';
const WHW_INSP_VERIFY_PIN = 'WHW_INSP_VERIFY_PIN';
const WHW_VALIDATE_PIN = 'WHW_VALIDATE_PIN';
const WHW_VALIDATE_PIN_SUCCESS = 'WHW_VALIDATE_PIN_SUCCESS';
const WHW_VALIDATE_PIN_FAIL = 'WHW_VALIDATE_PIN_FAIL';
const WHW_RESEND_EMAIL_MTN_FLAGS = 'WHW_RESEND_EMAIL_MTN_FLAGS';
const WHW_SEND_OTP_EMAIL = 'WHW_SEND_OTP_EMAIL';
const WHW_SEND_OTP_EMAIL_SUCCESS = 'WHW_SEND_OTP_EMAIL_SUCCESS';
const WHW_SEND_OTP_EMAIL_FAIL = 'WHW_SEND_OTP_EMAIL_FAIL';
const WHW_VERIFY_EMAIL = 'WHW_VERIFY_EMAIL';
const WHW_VERIFY_EMAIL_AUTH_CODE = 'WHW_VERIFY_EMAIL_AUTH_CODE';
const EMAIL_OTP_SEND_MSG_AUTH_TRIGGER = 'EMAIL_OTP_SEND_MSG_AUTH_TRIGGER';
const EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS = 'EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS';
const EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL = 'EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL';
const EMAIL_VALIDATE_OTP = 'EMAIL_VALIDATE_OTP';
const EMAIL_VALIDATE_OTP_SUCCESS = 'EMAIL_VALIDATE_OTP_SUCCESS';
const EMAIL_VALIDATE_OTP_FAIL = 'EMAIL_VALIDATE_OTP_FAIL';
const EMAIL_OTP_SEND_MSG_AUTH_TEXT = 'EMAIL_OTP_SEND_MSG_AUTH_TEXT';
const EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS = 'EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS';
const EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL = 'EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL';
const WHW_ACCEPT_PLANS = 'WHW_ACCEPT_PLANS';
const WHW_PLANS_CONFIRMATION = 'WHW_PLANS_CONFIRMATION';
const WHW_PLANS_CONFIRMATION_SUCCESS = 'WHW_PLANS_CONFIRMATION_SUCCESS';
const WHW_PLANS_CONFIRMATION_FAIL = 'WHW_PLANS_CONFIRMATION_FAIL';
const WHW_CBAND_QUALIFICATION = 'WHW_CBAND_QUALIFICATION';
const WHW_CBAND_QUALIFICATION_SUCCESS = 'WHW_CBAND_QUALIFICATION_SUCCESS';
const WHW_CBAND_QUALIFICATION_FAIL = 'WHW_CBAND_QUALIFICATION_FAIL';
const WHW_GETPLANS = 'WHW_GET_PLANS';
const WHW_GETPLANS_SUCCESS = 'WHW_GET_PLANS_SUCCESS';
const WHW_GETPLANS_FAIL = 'WHW_GET_PLANS_FAIL';
const WHW_UPDATECART = 'WHW_UPDATECART';
const WHW_UPDATECART_SUCCESS = 'WHW_UPDATECART_SUCCESS';
const WHW_UPDATECART_FAIL = 'WHW_UPDATECART_FAIL';
const WHW_INSPECIO_GETPLANS = 'WHW_INSPECIO_GETPLANS';
const WHW_INSPECIO_GETPLANS_SUCCESS = 'WHW_INSPECIO_GETPLANS_SUCCESS';
const WHW_INSPECIO_GETPLANS_FAIL = 'WHW_INSPECIO_GETPLANS_FAIL';
const WHW_INSPECIO_VALIDATEPIN = 'WHW_INSPECIO_VALIDATEPIN';
const WHW_INSPECIO_VALIDATEPIN_SUCCESS = 'WHW_INSPECIO_VALIDATEPIN_SUCCESS';
const WHW_INSPECIO_VALIDATEPIN_FAIL = 'WHW_INSPECIO_VALIDATEPIN_FAIL';
const WHW_PLANS_SUBMIT = 'WHW_PLANS_SUBMIT';
const WHW_PLANS_SUBMIT_SUCCESS = 'WHW_PLANS_SUBMIT_SUCCESS';
const WHW_PLANS_SUBMIT_FAIL = 'WHW_PLANS_SUBMIT_FAIL';
const WHW_RETRIEVE_CART = 'WHW_RETRIEVE_CART';
const WHW_RETRIEVE_CART_SUCCESS = 'WHW_RETRIEVE_CART_SUCCESS';
const WHW_RETRIEVE_CART_FAIL = 'WHW_RETRIEVE_CART_FAIL';
const WHW_DECLINE_PLANS_UPDATE = 'WHW_DECLINE_PLANS_UPDATE';
const WHW_SEND_DECLINE_PLANS = 'WHW_SEND_DECLINE_PLANS';
const WHW_SEND_DECLINE_PLANS_SUCCESS = 'WHW_SEND_DECLINE_PLANS_SUCCESS';
const WHW_SEND_DECLINE_PLANS_FAIL = 'WHW_SEND_DECLINE_PLANS_FAIL';
const WHW_SEND_ERROR_MESSAGE = 'WHW_SEND_ERROR_MESSAGE';
const WHW_SEND_ERROR_MESSAGE_SUCCESS = 'WHW_SEND_ERROR_MESSAGE_SUCCESS';
const WHW_SEND_ERROR_MESSAGE_FAIL = 'WHW_SEND_ERROR_MESSAGE_FAIL';
const WHW_ORDER_CONFIRMATION = 'WHW_ORDER_CONFIRMATION';

export {
  WHW_GET_EMAIL_AND_MTN,
  WHW_GET_EMAIL_AND_MTN_SUCCESS,
  WHW_GET_EMAIL_AND_MTN_FAIL,
  WHW_GEN_INSPICIO_ID,
  WHW_GEN_INSPICIO_ID_SUCCESS,
  WHW_GEN_INSPICIO_ID_FAIL,
  WHW_SEND_SMS_EMAIL_INSPICIO,
  WHW_SEND_SMS_EMAIL_INSPICIO_SUCCESS,
  WHW_SEND_SMS_EMAIL_INSPICIO_FAIL,
  WHW_INITIAL_STATE,
  WHW_INSPECIO_FORGET_PIN,
  WHW_SEND_MESSAGE_INSPICIO,
  WHW_INSPECIO_SHOWFORGETPIN_FAIL,
  WHW_INSPECIO_SENDMESSAGE_FAIL,
  WHW_VALIDATE_PIN,
  WHW_VALIDATE_PIN_FAIL,
  WHW_RESEND_EMAIL_MTN_FLAGS,
  WHW_INSPECIO_SHOWFORGETPIN_SUCCESS,
  WHW_INSPECIO_SENDMESSAGE_SUCCESS,
  WHW_INSP_VERIFY_PIN,
  WHW_VALIDATE_PIN_SUCCESS,
  WHW_SEND_OTP_EMAIL,
  WHW_SEND_OTP_EMAIL_SUCCESS,
  WHW_SEND_OTP_EMAIL_FAIL,
  WHW_VERIFY_EMAIL,
  WHW_VERIFY_EMAIL_AUTH_CODE,
  EMAIL_OTP_SEND_MSG_AUTH_TRIGGER,
  EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS,
  EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL,
  EMAIL_VALIDATE_OTP,
  EMAIL_VALIDATE_OTP_SUCCESS,
  EMAIL_VALIDATE_OTP_FAIL,
  EMAIL_OTP_SEND_MSG_AUTH_TEXT,
  EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS,
  EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL,
  WHW_ACCEPT_PLANS,
  WHW_PLANS_CONFIRMATION,
  WHW_PLANS_CONFIRMATION_SUCCESS,
  WHW_PLANS_CONFIRMATION_FAIL,
  WHW_GETPLANS,
  WHW_GETPLANS_SUCCESS,
  WHW_GETPLANS_FAIL,
  WHW_UPDATECART,
  WHW_UPDATECART_SUCCESS,
  WHW_UPDATECART_FAIL,
  WHW_INSPECIO_GETPLANS,
  WHW_INSPECIO_GETPLANS_SUCCESS,
  WHW_INSPECIO_GETPLANS_FAIL,
  WHW_INSPECIO_VALIDATEPIN,
  WHW_INSPECIO_VALIDATEPIN_SUCCESS,
  WHW_INSPECIO_VALIDATEPIN_FAIL,

  WHW_PLANS_SUBMIT,
  WHW_PLANS_SUBMIT_SUCCESS,
  WHW_PLANS_SUBMIT_FAIL,
  WHW_RETRIEVE_CART,
  WHW_RETRIEVE_CART_SUCCESS,
  WHW_RETRIEVE_CART_FAIL,
  WHW_DECLINE_PLANS_UPDATE,
  WHW_SEND_DECLINE_PLANS,
  WHW_SEND_DECLINE_PLANS_SUCCESS,
  WHW_SEND_DECLINE_PLANS_FAIL,
  WHW_SEND_ERROR_MESSAGE,
  WHW_SEND_ERROR_MESSAGE_SUCCESS,
  WHW_SEND_ERROR_MESSAGE_FAIL,
  WHW_CBAND_QUALIFICATION,
  WHW_CBAND_QUALIFICATION_SUCCESS,
  WHW_CBAND_QUALIFICATION_FAIL,
  WHW_ORDER_CONFIRMATION,
};
